import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const p = {
  display: "block"
}, f = ({ size: l = 16, useVw: e, useRem: c, color: n, withColor: o, removeClassName: t, disableSSR: m, style: r, ...d }) => {
  const x = r ? { ...p, ...r } : p;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-Startupxinbiwakuang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: e ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (c ? "rem" : "px"), height: e ? ((l || 0) / 375 * 100).toFixed(5) + "vw" : l + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...d }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-Startupæ°å¸æç¿"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? i(n, 0, "#262933") : "#262933",
        datafollowfill: o ? i(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M9.184 11.044c.597-1.676 1.498-3.194 2.644-4.411-4.146 1.061-7.199 6.22-6.484 12.04.727 5.92 4.964 9.602 9.166 8.88-1.426-.736-2.69-1.869-3.69-3.28a.9.9 0 0 1 1.47-1.04c1.826 2.58 4.521 3.874 7.247 3.344 2.753-.535 5.065-2.836 6.209-6.05a.9.9 0 0 1 1.695.604c-1.243 3.493-3.808 6.3-7.154 7.123l.002.01-5.3 1.03C9.326 30.396 4.364 25.47 3.556 18.893c-.806-6.57 2.719-13.025 8.295-14.11l4.856-.943.037-.007.036-.007.371-.072.002.01c3.417-.49 6.594 1.234 8.65 4.14a.9.9 0 1 1-1.468 1.04c-1.82-2.57-4.5-3.864-7.216-3.35l-.064.012c-2.738.547-5.037 2.842-6.176 6.043a.9.9 0 1 1-1.696-.604Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M20.07 19.278a.3.3 0 0 0 .237-.327l-.111-.904a.254.254 0 0 0-.305-.222l-2.239.436-.143-1.164 1.874-.364a.3.3 0 0 0 .237-.327l-.11-.905a.254.254 0 0 0-.306-.221l-1.873.364-.136-1.108 2.239-.435a.3.3 0 0 0 .237-.327l-.11-.904a.254.254 0 0 0-.306-.222l-3.389.659a.3.3 0 0 0-.237.327l.746 6.081c.02.152.156.25.305.222l3.39-.659Zm7.202-7.841a.256.256 0 0 0-.305-.288l-.924.18a.302.302 0 0 0-.238.267l-.306 3.423-1.285-3.127a.253.253 0 0 0-.286-.152l-.592.115a.301.301 0 0 0-.237.254l-.475 3.47-1.112-3.149a.253.253 0 0 0-.292-.164l-.923.18a.298.298 0 0 0-.222.39l2.207 5.798a.253.253 0 0 0 .29.158l.736-.143a.301.301 0 0 0 .236-.249l.5-3.241 1.255 2.9c.048.11.164.17.285.147l.744-.144a.301.301 0 0 0 .238-.262l.706-6.363Zm-12.068 8.506a.3.3 0 0 1-.237.327l-.813.158a.254.254 0 0 1-.254-.094l-2.166-2.849.376 3.06a.3.3 0 0 1-.238.327l-.88.17a.254.254 0 0 1-.304-.22l-.747-6.082a.3.3 0 0 1 .238-.327l.813-.158a.254.254 0 0 1 .253.094l2.167 2.849-.376-3.06a.3.3 0 0 1 .238-.327l.879-.17c.15-.03.286.07.305.22l.746 6.082Z"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
